import React from "react";
import { useWarehouseContext } from "./WarehouseProvider";
import { WeightCapture } from "./components/WeightCapture";
import contentsWeightIcon from "./images/contents-weight-icon.png";

const TITLE = "Weigh Total Contents";

export const ContentWeightCapture = () => {
  const { contentWeight, setContentWeight } = useWarehouseContext();

  return (
    <WeightCapture
      title={TITLE}
      instruction={
        <div className="flex flex-col gap-10">
          <div>
            Record the weight of the entire Trade-in's contents in the control{" "}
            <br /> container, excluding any packaging material.
          </div>
          <div className="bg-[#060E23] border border-[#282F44] rounded-xl px-4 py-3 mb-3 text-center">
            <span className="font-mono text-lg leading-tight uppercase text-white">
              ⚖️ WEIGH: control container + contents
            </span>
          </div>
        </div>
      }
      icon={contentsWeightIcon}
      iconAlt="Contents Weight"
      value={contentWeight}
      onChange={setContentWeight}
      showRejectButton={false}
    />
  );
};

ContentWeightCapture.title = TITLE;
